module.exports = __webpack_public_path__ + "img/ic_client.820483f8.svg";